import { Skeleton } from "@mui/material";

const AddressListSkeleton = () => {
  return (
    <div className="">
      <div className="row">
        {Array.from(new Array(2)).map((_, index) => (
          <div key={index} className="col-md-6">
            <div className="card mb-3 card-navya">
              <div className="card-body">
                <div className="row">
                  {/* Icon Skeleton */}
                  <div className="row">
                    <div className="col-md-2">
                      <div className="pe-3">
                        <Skeleton variant="circular" width={40} height={40} />
                      </div>
                    </div>

                    {/* Text Skeleton */}
                    <div className="col-md-10">
                      <div>
                        <Skeleton variant="text" height={30} />
                        <Skeleton
                          variant="text"
                          width={150}
                          height={20}
                          className="mb-2"
                        />

                        {/* Button Skeletons */}
                        <div className="row">
                          <div className="col-md-6">
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={30}
                            />
                          </div>
                          <div className="col-md-6">
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={30}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddressListSkeleton;
